import Zone from "@insite/client-framework/Components/Zone";
import {
    ExcludeFromNavigation,
    ExcludeFromSignInRequired,
    HideFooter,
    HideFromSearchEngines,
    HideFromSiteSearch,
    HideHeader,
    HorizontalRule,
    MetaDescription,
    MetaKeywords,
    OpenGraphImage,
    OpenGraphTitle,
    OpenGraphUrl,
    StructuredPageData,
} from "@insite/client-framework/Types/FieldDefinition";
import PageModule from "@insite/client-framework/Types/PageModule";
import PageProps from "@insite/client-framework/Types/PageProps";
import Modals from "@insite/content-library/Components/Modals";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import MobiusPage from "@insite/mobius/Page";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { css } from "styled-components";

export interface PageStyles {
    Pagecontainer?: InjectableCss;
}
export const pageStyles: PageStyles = {
    Pagecontainer: {
        css: css`
            padding-top: 0 !important;
            .primary-btn {
                cursor: pointer;
                font-family: inherit;
                height: 40px;
                line-height: 1;
                backface-visibility: hidden;
                transition: all 200ms ease-in-out 0s;
                padding: 10px 21px;
                background: #3666b1;
                border: 2px solid #3666b1;
                color: rgb(255, 255, 255);
                font-weight: bold;
                span {
                    color: #fff;
                }
            }
            .secondary-btn {
                height: 40px;
                line-height: 1;
                transition: all 200ms ease-in-out;
                padding: 0 21px;
                border: 2px solid #3666b1;
                background: transparent;
                color: #3666b1;
            }

            .embed form,
            .embed body {
                margin: 0 !important;
                border: 1px solid red !important;
            }
            .page-forms {
                margin: auto !important;
                margin-top: 15px !important;
                padding: 30px;
                box-shadow: 0 1px 6px 1px rgba(133, 133, 133, 0.25);
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(
                        theme,
                        [
                            css`
                                width: 100%;
                                padding: 15px;
                            `,
                            css`
                                width: 100%;
                                padding: 15px;
                            `,
                            css`
                                width: 90%;
                            `,
                            css`
                                width: 60%;
                            `,
                            null,
                        ],
                        "min",
                    )}
            }
        `,
    },
};

const styles = pageStyles;
const Page: React.FunctionComponent<PageProps> = ({ id }) => (
    <MobiusPage {...styles.Pagecontainer}>
        <Zone contentId={id} zoneName="Content" requireRows />
        <Modals />
    </MobiusPage>
);

const pageModule: PageModule = {
    component: Page,
    definition: {
        hasEditableTitle: true,
        hasEditableUrlSegment: true,
        pageType: "Content",
        fieldDefinitions: [
            MetaKeywords,
            MetaDescription,
            OpenGraphTitle,
            OpenGraphUrl,
            OpenGraphImage,
            StructuredPageData,
            {
                ...HorizontalRule,
                sortOrder: 199,
            },
            HideHeader,
            HideFooter,
            HideFromSearchEngines,
            HideFromSiteSearch,
            ExcludeFromNavigation,
            ExcludeFromSignInRequired,
        ],
    },
};

export default pageModule;
